<template>
    <div id="main-header" :class="{ 'sidebar-open': isMainSidebarOpen }">
        <div class="header-title">
            <button class="toggle-main-sidebar" @click="toggleMainSidebar()"><i :class="{ 'fas fa-bars': !isMainSidebarOpen, 'fas fa-times': isMainSidebarOpen }"></i></button>
            <h1 class="text" v-if="!isMobile" style="display: flex">LFED Workplace<beta-tag></beta-tag></h1>
            <h1 class="text" v-else>PW<beta-tag></beta-tag></h1>
        </div>
        <div class="header-actions">
            <div class="header-action">
                <button class="header-action-btn dropdown-toggle language" id="language-dropdown-menu" data-toggle="dropdown">
                    <span class="icon"><i class="fas fa-globe"></i></span>
                    <div class="dropdown-menu" aria-labelledby="language-dropdown-menu">
                        <button class="dropdown-btn" @click="setLanguage('en')">
                            <i class="flag-icon flag-icon-us"></i>
                            English
                            <span class="green-dot" v-if="isCurrentLanguage('en')"></span>
                        </button>
                        <button class="dropdown-btn" @click="setLanguage('ar')">
                            <i class="flag-icon flag-icon-lb"></i>
                            عربي
                            <span class="green-dot" v-if="isCurrentLanguage('ar')"></span>
                        </button>
                    </div>
                </button>
            </div>
            <div class="header-action">
                <button class="header-action-btn dropdown-toggle notifications" id="notifications-dropdown-menu" data-toggle="dropdown" title="Notifications">
                    <span class="icon"><i class="fas fa-bell"></i></span>
                    <span class="counter" v-if="numberOfNotifications === '...' || numberOfNotifications > 0">{{ numberOfNotifications }}</span>
                    <notifications-dropdown></notifications-dropdown>
                </button>
            </div>
            <div class="header-action">
                <button class="header-action-btn dropdown-toggle initials" id="my-profile-dropdown-menu" data-toggle="dropdown" :title="userFullName">
                    <span class="icon">{{ getInitials(userFullName) }}</span>
                    <div class="dropdown-menu" aria-labelledby="my-profile-dropdown-menu">
                        <router-link class="dropdown-btn" to="/change-password"><i class="fas fa-unlock"></i>Change Password</router-link>
                        <router-link class="dropdown-btn" to="/settings"><i class="fas fa-cog"></i>Settings</router-link>
                        <router-link class="dropdown-btn" to="/logout"><i class="fas fa-power-off"></i>Logout</router-link>
                    </div>
                </button>
            </div>
            <div class="header-action">
                <button :class="[ 'header-action-btn', { 'active': isTasksSidebarOpen } ]" @click="toggleTasksSidebar()" title="My Tasks">
                    <span class="icon"><i class="fas fa-tasks"></i></span>
                    <span class="counter" v-if="numberOfUnreadTasks > 0">{{ numberOfUnreadTasks }}</span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import Session from "@/utils/Session";
import NotificationsDropdown from "@/components/dropdowns/NotificationsDropdown";
import BetaTag from "@/components/BetaTag";

export default {
    name: "main-header",
    components: {
        NotificationsDropdown,
        BetaTag
    },
    methods: {
        toggleMainSidebar() {
            this.isMainSidebarOpen
                ? this.$store.dispatch("mainSidebar/closeMainSidebar") 
                : this.$store.dispatch("mainSidebar/openMainSidebar");
        },
        toggleTasksSidebar() {
            this.isTasksSidebarOpen 
                ? this.$store.dispatch("closeTasksSidebar") 
                : this.$store.dispatch("openTasksSidebar");
        },
        setLanguage(language) {
            this.$store.dispatch("setLanguage", language);
        },
        isCurrentLanguage(language) {
            return this.$store.getters.appLanguage === language;
        }
    },
    computed: {
        isMainSidebarOpen() {
            return this.$store.getters['mainSidebar/isMainSidebarOpen'];
        },
        isTasksSidebarOpen() {
            return this.$store.getters.isTasksSidebarOpen;
        },
        userFullName() {
            let session = new Session();
            let claims = session.accessToken.claims;
            return `${claims.given_name} ${claims.family_name}`;
        },
        numberOfUnreadTasks() {
            return this.$store.getters.numberOfUnreadTasks;
        },
        numberOfNotifications() {
            let numberOfNotifications = this.$store.getters["notifications/numberOfNotifications"];
            return numberOfNotifications <= 100 ? numberOfNotifications : "...";
        },
        isMobile() {
            return this.$store.getters.isMobile;
        }
    }
}
</script>

<style lang="scss" scoped>
#main-header {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    position: fixed;
    width: 100%;
    height: $header-height;
    padding: 0px 0px 0px 20px;
    background-color: $lighter-gray;
    border-bottom: 1px solid $light-gray;
    z-index: 999;
    @include fastestTransition;
    .toggle-main-sidebar {
        margin: 0px 15px 0px 0px;
        padding: 0;
        font-size: 15px;
        background-color: transparent;
        color: $darker-gray;
        @include removeBootstrapOutline;
        i {
            margin: 0;
            padding: 0;
        }
    }
    .header-title {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        flex-grow: 1;
        .text {
            margin: 0;
            padding: 0;
            font-size: 16px;
            font-family: $lato;
            font-weight: 700;
            color: $darker-gray;
        }
    }
    .header-actions {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        flex-grow: 0;
        .header-action {
            .header-action-btn {
                display: flex;
                align-items: center;
                justify-content: center;
                width: $header-height;
                height: $header-height;
                background-color: transparent;
                position: relative;
                margin: 0;
                @include removeBootstrapOutline;
                @include fastestTransition;
                border-left: 1px solid $light-gray!important;
                .icon {
                    font-size: 18px;
                    color: $darkest-gray;
                }
                .counter {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    position: absolute;
                    width: 16px;
                    height: 16px;
                    top: 8px;
                    right: 10px;
                    font-size: 8px;
                    border-radius: 50%;
                    background-color: $red;
                    color: $white;
                }
                &.initials {
                    .icon {
                        font-family: $montserrat;
                        font-weight: 700;
                        color: $darker-gray;
                    }
                }
                &.language {
                    padding: 0;
                    background: none;
                    border: none;
                    cursor: pointer;
                    @include removeBootstrapOutline;
                    @include fastestTransition;
                    &:hover, &.active {
                        color: $primary;
                    }
                }
                &.dropdown-toggle {
                    .dropdown-menu {
                        top: 5px!important;
                        padding: 0;
                        border: none;
                        border-radius: 2px;
                        overflow: hidden;
                        box-shadow: 0px 0px 5px 0px $gray;
                        .dropdown-btn {
                            display: flex;
                            align-items: center;
                            width: 100%;
                            padding: 10px;
                            font-family: $lato;
                            font-size: 14px;
                            font-weight: 700;
                            background-color: $lightest-gray;
                            color: $text-color!important;
                            text-decoration: none!important;
                            cursor: pointer;
                            @include removeBootstrapOutline;
                            @include fastestTransition;
                            i, .flag-icon {
                                margin: 0px 10px 0px 0px;
                            }
                            .green-dot {
                                display: flex;
                                width: 6px;
                                height: 6px;
                                margin: 0px 0px 0px 20px;
                                background-color: $dark-green;
                                border-radius: 50%;
                            }
                            &:hover {
                                background-color: $lighter-gray;
                            }
                        }
                    }
                    &:after {
                        display: none;
                    }
                }
                &.soon {
                    .icon {
                        color: $dark-gray;
                    }
                    .soon-label {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        position: absolute;
                        width: 100%;
                        bottom: 0;
                        left: 0;
                        padding: 1px 5px;
                        font-size: 9px;
                        text-transform: uppercase;
                        font-family: $montserrat;
                        font-weight: 700;
                        background-color: $green;
                        color: $white;
                    }
                }
                &.active, &:hover {
                    background-color: $light-gray;
                }
            }
        }
    }
    &.sidebar-open {
        width: calc(100% - #{$sidebar-width});
    }
    @media screen and (max-width: $breakpoint-sm) {
        padding: 0px 0px 0px 15px;
        width: 100%;
        .toggle-main-sidebar {
            margin: 0px 10px 0px 0px;
        }
        .header-title {
            .text {
                font-size: 15px;
            }
        }
        .header-actions {
            .header-action {
                .icon {
                    font-size: 15px;
                }
            }
        }
        &.sidebar-open {
            width: 100%;
        }
    }
}

.dark {
    #main-header {
        background-color: $extra-darker-gray;
        border-bottom: 1px solid $extra-dark-gray;
        .toggle-main-sidebar {
            color: $light-gray;
        }
        .header-title {
            .text {
                color: $light-gray;
            }
        }
        .header-actions {
            .header-action {
                border-left: none!important;
                .header-action-btn {
                    border-left: 1px solid $extra-dark-gray!important;
                    .icon {
                        color: $dark-gray;
                    }
                    &.active {
                        background-color: $darkest-gray;
                    }
                    &.dropdown-toggle {
                        .dropdown-menu {
                            box-shadow: none!important;
                            background-color: $extra-darker-gray;
                            .dropdown-btn {
                                background-color: $extra-darker-gray;
                                color: $lighter-gray!important;
                                &:hover {
                                    background-color: $extra-dark-gray;
                                }
                            }
                        }
                    }
                }
                &.initials {
                    .icon {
                        color: $light-gray;
                    }
                }
                &.active, &:hover {
                    background-color: $darkest-gray;
                    .header-action-btn {
                        background-color: $darkest-gray;
                    }

                }
            }
        }
    }
}
</style>
